import React from 'react';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, Modal, Typography } from 'antd';
import './index.less';

const { Paragraph, Text, Title } = Typography;

export interface ImportFieldErrorModalProps {
  open: boolean;
  downloadUrl?: string;
  skipLoading?: boolean;
  onClose: () => void;
  onSkip: () => void;
  onDownload: () => void;
}

const ImportFieldErrorModal: React.FC<ImportFieldErrorModalProps> = ({ open, downloadUrl, skipLoading, onClose, onSkip, onDownload }) => (
  <Modal open={open} onCancel={onClose} footer={null} destroyOnHidden width={460} className="import-field-error-modal">
    <div className="import-field-error-modal__content">
      <div className="import-field-error-modal__icon">
        <ExclamationCircleOutlined />
      </div>
      <div className="import-field-error-modal__body">
        <Title level={4} className="import-field-error-modal__title">
          信息异常
        </Title>
        <Paragraph className="import-field-error-modal__description">
          检测到已上传表格数据存在异常，请下载
          <Button type="link" className="import-field-error-modal__link" onClick={onDownload} disabled={!downloadUrl}>
            报错说明文件
          </Button>
          <Text>，按提示修改后重新上传。</Text>
        </Paragraph>
        <div className="import-field-error-modal__actions">
          <Button onClick={onSkip} loading={skipLoading}>
            跳过
          </Button>
          <Button type="primary" onClick={onClose} disabled={skipLoading}>
            重新上传
          </Button>
        </div>
      </div>
    </div>
  </Modal>
);

export default ImportFieldErrorModal;
